import React, { useState, useEffect, memo  } from 'react';
import reactToWebComponent from 'react-to-webcomponent';
import PropTypes from 'prop-types';
import { Multiselect } from 'multiselect-react-dropdown';
import {connect} from "react-redux";

import { setSalutationAction } from "../../actions/contactAction";
import { setFirstNameAction } from "../../actions/contactAction";
import { setSurnameAction } from "../../actions/contactAction";
import { setEmailAction } from "../../actions/contactAction";
import { setLandAction } from "../../actions/contactAction";
import { setStreetAction } from "../../actions/contactAction";
import { setNearAction } from "../../actions/contactAction";
import { setPlzAction } from "../../actions/contactAction";
import { setOrtAction } from "../../actions/contactAction";
import { setTelephoneAction } from "../../actions/contactAction";
import { setMessageAction } from "../../actions/contactAction";
import Language from '../../language/language.json';
import getAuth from '../../api/auth';
import getinquiriesForm from '../../api/inquiriesForm';

const mapState = state => ({
    data : state.contact,
    formData : state.formData
});

const mapDispatchToProps = dispatch => ({
    setSalutation:      (payload) => dispatch(setSalutationAction(payload)),
    setFirstName:       (payload) => dispatch(setFirstNameAction(payload)),
    setSurname:         (payload) => dispatch(setSurnameAction(payload)),
    setEmail:           (payload) => dispatch(setEmailAction(payload)),
    setLand:            (payload) => dispatch(setLandAction(payload)),
    setStreet:          (payload) => dispatch(setStreetAction(payload)),
    setNear:            (payload) => dispatch(setNearAction(payload)),
    setPlz:             (payload) => dispatch(setPlzAction(payload)),
    setOrt:             (payload) => dispatch(setOrtAction(payload)),
    setTelephone:       (payload) => dispatch(setTelephoneAction(payload)),
    setMessage:         (payload) => dispatch(setMessageAction(payload)),
});

const Contact = (props) => {

    const salutation    = props.data.salutation;
    const firstName     = props.data.firstName;
    const surname       = props.data.surname;
    const email         = props.data.email;
    const land          = props.data.land;
    const street        = props.data.street;
    const near          = props.data.near;
    const plz           = props.data.plz;
    const ort           = props.data.ort;
    const telephone     = props.data.telephone;
    const message       = props.data.message;

    let salutationInputRef = HTMLInputElement | null;
    let landInputRef = HTMLInputElement | null;

    const handleFirstNameChange = (e) => {
        const value = e.target.value;
        props.setFirstName(value);
    };

    const handleSurnameChange = (e) => {
        const value = e.target.value;
        props.setSurname(value);
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        props.setEmail(value);
    };
    
    const handleLandChange = (selectedList, selectedItem) => {
        const value = selectedList;
        props.setLand(value);
    };

    const handleSalutationChange = (selectedList, selectedItem) => {
        const value = selectedList;
        props.setSalutation(value);
    };

    const handleStreetChange = (e) => {
        const value = e.target.value;
        props.setStreet(value);
    };

    const handleNearChange = (e) => {
        const value = e.target.value;
        props.setNear(value);
    };

    const handlePlzChange = (e) => {
        const value = e.target.value;
        props.setPlz(value);
    };

    const handleOrtChange = (e) => {
        const value = e.target.value;
        props.setOrt(value);
    };

    const handleTelephoneChange = (e) => {
        const value = e.target.value;
        props.setTelephone(value);
    };

    const handleMessageChange = (e) => {
        const value = e.target.value;
        props.setMessage(value);
    };
    
    const [landOptions, setLandOptions] = useState([]);
    const [salutationOptions, setSalutationOptions] = useState([]);
    
    const [token, setToken] = useState(props.token);
    const [uuid, setUuid] = useState(props.uuid);
    const [clientBearerToken, setBearerToken] = useState(localStorage.getItem('clientBearerToken'));
    var localBearerToken = '';
    var localTokenExpiresAt = '';
    var localFormId = '';
    var localInquiryToken = '';

     useEffect(() => {

        var tokenExpiresAtLocal = new Date(localTokenExpiresAt).getTime();

        (async () => {
            
            if(localBearerToken == '' || localBearerToken == null || (tokenExpiresAtLocal <= Date.now()) ){
                await getAuth(token, uuid).then((data)=>{
                    if(data){
                        if(props.prefix == "Client"){
                            localStorage.setItem('clientBearerToken', data.token.token);
                            localStorage.setItem('clientTokenExpiresAt', data.token.expires_at);
                            localStorage.setItem('clientFormId', data.params.id);
                        }

                        if(props.prefix == "Pool"){
                            localStorage.setItem('poolBearerToken', data.token.token);
                            localStorage.setItem('poolTokenExpiresAt', data.token.expires_at);
                            localStorage.setItem('poolFormId', data.params.id);
                        }
                    }

                    if(props.prefix == "Client"){
                        localBearerToken = localStorage.getItem('clientBearerToken')
                        localTokenExpiresAt = localStorage.getItem('clientTokenExpiresAt')
                        localFormId = localStorage.getItem('clientFormId')
    
                        setBearerToken(localStorage.getItem('clientBearerToken'))
                    }

                


                    if(localBearerToken && localFormId){
                        getinquiriesForm(localBearerToken, localFormId, props.prefix).then((inquiry)=>{
                            if(inquiry){
                                setLandOptions(inquiry.params.countries);
                                setSalutationOptions(inquiry.params.salutations);
                            }
                        });
                    }
                });
            }
            
        })();

     }, []);


    return (

        <>
            <h3 className='form_title'>{Language[props.lang].contact_form_title}</h3>
            <div>
                <div className='form_field_row cus_pb_15'>
                    <label>{Language[props.lang].salutation}</label>
                    <fieldset className={salutationOptions.length > 0 ? 'field_33' : ''} style={{display: salutationOptions.length > 0 ? "block" : "none"}}>
                        <div className='icon_box'>
                            <Multiselect
                                id="salutation"
                                options={salutationOptions}
                                selectedValues={salutation} 
                                onSelect={handleSalutationChange} 
                                // onRemove={onRemove} 
                                displayValue="name"
                                placeholder={Language[props.lang].salutation_placeholder}
                                emptyRecordMsg=""
                                avoidHighlightFirstOption={true}
                                hidePlaceholder={true}
                                showArrow={true}
                                // style={multiselectstyle}
                                showCheckbox={false}
                                singleSelect={false}
                                selectionLimit={1}
                                required
                                ref={node => { salutationInputRef = node; }}
                                singleSelect
                            />
                            <div className="bt_ico" onClick={ () => salutationInputRef.onFocus()} htmlFor="salutation"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down" className="svg-inline--fa fa-chevron-down " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"></path></svg></div>
                        </div>
                    </fieldset>
                    <fieldset className={salutationOptions.length > 0 ? 'field_33' : 'field_50'}>
                        <div className='icon_box'>
                            <input type="text" id="firstName" placeholder={Language[props.lang].firstName_placeholder} value={firstName} onChange={handleFirstNameChange} required />
                        </div>
                    </fieldset>
                    <fieldset className={salutationOptions.length > 0 ? 'field_33' : 'field_50'}>
                        <div className='icon_box'>
                            <input type="text" id="surname" placeholder={Language[props.lang].surname_placeholder} value={surname} onChange={handleSurnameChange} required />
                        </div>
                    </fieldset>
                </div>
                <div className='form_field_row'>
                    <fieldset className='field_100'>
                        <div className='icon_box'>
                            <input type="email" id="email" placeholder={Language[props.lang].email_placeholder} value={email} onChange={handleEmailChange} required />
                        </div>
                    </fieldset>
                </div>
                <div className='form_field_row'>
                    <label>{Language[props.lang].land}</label>
                    <fieldset className='field_100' style={{display: landOptions.length > 0 ? "block" : "none"}}>
                        <div className='icon_box'>
                            <Multiselect
                                id="land"
                                options={landOptions}
                                selectedValues={land} 
                                onSelect={handleLandChange} 
                                // onRemove={onRemove} 
                                displayValue="name"
                                placeholder={Language[props.lang].land_placeholder}
                                emptyRecordMsg=""
                                avoidHighlightFirstOption={true}
                                hidePlaceholder={true}
                                showArrow={true}
                                // style={multiselectstyle}
                                showCheckbox={false}
                                singleSelect={false}
                                selectionLimit={1}
                                required
                                ref={node => { landInputRef = node; }}
                                singleSelect
                            />
                            <div className="bt_ico" onClick={ () => landInputRef.onFocus()} htmlFor="land" ><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down" className="svg-inline--fa fa-chevron-down " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"></path></svg></div>
                        </div>
                    </fieldset>
                </div>
                <div className='form_field_row cus_pb_15'>
                    <label>{Language[props.lang].street}</label>
                    <fieldset className='field_66'>
                        <div className='icon_box'>
                            <input type="text" id="street" placeholder={Language[props.lang].street_placeholder} value={street} onChange={handleStreetChange}  />
                        </div>
                    </fieldset>
                    <fieldset className='field_33'>
                        <div className='icon_box'>
                            <input type="text" id="near" placeholder={Language[props.lang].near_placeholder} value={near} onChange={handleNearChange} />
                        </div>
                    </fieldset>
                </div>
                <div className='form_field_row cus_pb_15'>
                    <fieldset className='field_33'>
                        <div className='icon_box'>
                            <input type="text" id="plz" placeholder={Language[props.lang].plz_placeholder} value={plz} onChange={handlePlzChange} />
                        </div>
                    </fieldset>
                    <fieldset className='field_66'>
                        <div className='icon_box'>
                            <input type="text" id="ort" placeholder={Language[props.lang].ort_placeholder} value={ort} onChange={handleOrtChange} />
                        </div>
                    </fieldset>
                </div>
                <div className='form_field_row'>
                    <fieldset className='field_100'>
                        <div className='icon_box'>
                            <input type="text" id="telephone" placeholder={Language[props.lang].telephone_placeholder} value={telephone} onChange={handleTelephoneChange} />
                        </div>
                    </fieldset>
                </div>
                <div className='form_field_row cus_pb_15'>
                    <label>{Language[props.lang].message}</label>
                    <fieldset className='field_100'>
                        <div className='icon_box'>
                            <textarea id="message" placeholder={Language[props.lang].message_placeholder} value={message} onChange={handleMessageChange}></textarea>
                        </div>
                    </fieldset>
                </div>
            </div>
        </>
    );
};


Contact.propTypes = {
    lang: PropTypes.string,
    type: PropTypes.string,
    token: PropTypes.string,
    uuid: PropTypes.string,
    prefix: PropTypes.string,
}

export default connect(mapState, mapDispatchToProps)(Contact);